import { createSlice } from "@reduxjs/toolkit";

const player1 = localStorage.getItem("SPICY_PLAYER1")
  ? JSON.parse(localStorage.getItem("SPICY_PLAYER1"))
  : {
      name: "",
      gender: 2,
      orientation: 0,
      orientationCalc: 2,
      avatar:
        "https://desafios-picantes-bucket.dev12br.com/personagens/avatar/avatar_mulher_mulherGato.png",
    };

const player2 = localStorage.getItem("SPICY_PLAYER2")
  ? JSON.parse(localStorage.getItem("SPICY_PLAYER2"))
  : {
      name: "",
      gender: 1,
      orientation: 0,
      orientationCalc: 1,
      avatar:
        "https://desafios-picantes-bucket.dev12br.com/personagens/avatar/avatar_homem_bombeiro.png",
    };

export const playersSlice = createSlice({
  name: "players",
  initialState: {
    player1: player1,
    player2: player2,
  },
  reducers: {
    setPlayer1: (state, action) => {
      state.player1 = { ...state.player1, ...action.payload };
    },
    setPlayer2: (state, action) => {
      state.player2 = { ...state.player2, ...action.payload };
    },
  },
});

export const { setPlayer1, setPlayer2 } = playersSlice.actions;

export default playersSlice.reducer;
